import React, { useState } from 'react';
import axios from 'axios';
import API_BASE from '../api';

function FileUpload({ onTransactionsUpload }) {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) {
      for (const file of files) {
        const filename = file.name.toLowerCase();
        if (!filename.endsWith('.pdf') && !filename.endsWith('.csv')) {
          setError('Please select only PDF or CSV files');
          return;
        }
      }
    }

    setSelectedFiles(files);
    setError(null);
  };

  const handleUpload = async () => {
    if (selectedFiles.length === 0) {
      setError('Please select at least one PDF or CSV file');
      return;
    }

    setUploading(true);
    setError(null);

    const formData = new FormData();
    selectedFiles.forEach((file) => formData.append('files', file));

    try {
      const response = await axios.post(`${API_BASE}/api/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        const processedFiles = response.data.processedFiles || [];
        // Collect per-file parse errors (e.g. Gmail-print PDFs)
        const fileErrors = processedFiles
          .filter(f => f.error)
          .map(f => `⚠️ ${f.filename}: ${f.error}`);
        if (fileErrors.length > 0) {
          setError(fileErrors.join('\n\n'));
        }
        onTransactionsUpload(response.data.transactions, response.data.cardName || '', processedFiles);
        setSelectedFiles([]);
        document.getElementById('fileInput').value = '';
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Error uploading file');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="card">
      <h2>Upload Statement</h2>

      <div className="form-group">
        <label htmlFor="fileInput">Select Statement File(s) (PDF or CSV)</label>
        <input
          id="fileInput"
          type="file"
          multiple
          accept=".pdf,.csv"
          onChange={handleFileChange}
        />
        <label htmlFor="fileInput" className="file-input-label">
          Choose Files
        </label>
        {selectedFiles.length > 0 && (
          <div className="file-name success">Selected {selectedFiles.length} file(s)</div>
        )}
      </div>

      <button onClick={handleUpload} disabled={uploading}>
        {uploading ? 'Uploading...' : 'Upload & Categorize'}
      </button>

      {error && <div className="error" style={{ marginTop: '15px', whiteSpace: 'pre-wrap' }}>{error}</div>}
    </div>
  );
}

export default FileUpload;
